import { A11yModule } from '@angular/cdk/a11y';
import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { heroiconsAnnotation } from '@ld.consumer-portal/data-uri';
import { SvgIconComponent } from '@ld.consumer-portal/ui-shared';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

@Component({
  selector: 'ld-phone-authorization-modal',
  imports: [A11yModule, BaseModalComponent, MatProgressSpinnerModule, SvgIconComponent, TranslocoDirective],
  templateUrl: './phone-authorization-modal.component.html',
  styleUrl: './phone-authorization-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhoneAuthorizationModalComponent {
  private readonly transloco = inject(TranslocoService);

  protected readonly annotationIcon = heroiconsAnnotation;

  isOpen = input<boolean>(false);

  mode = input<'authorize' | 'revoke'>('authorize');

  phoneNumber = input<string>('');

  isLoading = input<boolean>(false);

  confirm = output<void>();

  cancel = output<void>();

  protected get formattedPhone(): string {
    const num = this.phoneNumber().replace(/\D/g, '');
    if (num.length === 10) {
      return `(${num.slice(0, 3)}) ${num.slice(3, 6)}-${num.slice(6)}`;
    }
    return this.phoneNumber();
  }

  protected get title(): string {
    return this.mode() === 'authorize'
      ? this.transloco.translate('phoneAuthModalTitleAuthorize')
      : this.transloco.translate('phoneAuthModalTitleRevoke');
  }

  protected get message(): string {
    if (this.mode() === 'authorize') {
      return this.transloco.translate('phoneAuthModalMessageAuthorize');
    }
    return this.transloco.translate('phoneAuthModalMessageRevoke', { phone: this.formattedPhone });
  }

  protected get confirmText(): string {
    return this.mode() === 'authorize'
      ? this.transloco.translate('phoneAuthModalButtonAuthorize')
      : this.transloco.translate('phoneAuthModalButtonRevoke');
  }

    protected get cancelText(): string {
      return this.transloco.translate('commonButtonsCancel');
    }

  protected get iconBgClass(): string {
    return this.mode() === 'authorize' ? 'bg-ld-success/20' : 'bg-ld-warning/20';
  }

  protected onConfirm(): void {
    if (!this.isLoading()) {
      this.confirm.emit();
    }
  }

  protected onCancel(): void {
    if (!this.isLoading()) {
      this.cancel.emit();
    }
  }

}
